import { render, staticRenderFns } from "./v-calendar.vue?vue&type=template&id=00cc900b&"
import script from "./v-calendar.vue?vue&type=script&lang=js&"
export * from "./v-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports